/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Sponsor } from '../models/Sponsor';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class SponsorService {

    /**
     * Get Sponsor list API Endpoint
     * Get Sponsor list
     * @param offset 
     * @param limit 
     * @returns any successful operation
     * @throws ApiError
     */
    public static sponsorList(
offset?: number,
limit?: number,
): CancelablePromise<{
status?: number;
message?: string;
data?: {
sponsors?: Array<Sponsor>;
count?: number;
};
}> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/sponsor',
            query: {
                'offset': offset,
                'limit': limit,
            },
            errors: {
                400: `Invalid Parameters supplied`,
                500: `Internal Server error`,
            },
        });
    }

}
